import React from "react";
import { Box, Button } from "@mui/material";
import WhiteLogo from "../../images/whiteLogo.svg";
import LinkedinLogo from "../../images/linkedin.svg";
import InstagramLogo from "../../images/instagram.svg";
import useIsMobile from "../../hooks/useIsMobile";
import { trackSocialClick, trackSignUpClick } from "../../utils/analytics";

const Footer = () => {
  const isMobile = useIsMobile();

  const handleSocialClick = (platform: string) => {
    trackSocialClick(platform);
  };

  const handleSignUpClick = () => {
    trackSignUpClick("footer");
    window.location.href = "/cadastro";
  };

  return (
    <footer>
      <Box
        sx={{
          background: "linear-gradient(to right, #226FE2, #0033FF)",
          width: "100%",
          minHeight: isMobile ? "200px" : "250px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "25px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-around",
            alignItems: "center",
            width: "100%",
            maxWidth: "1200px",
            gap: isMobile ? "30px" : "0",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: isMobile ? "center" : "flex-start",
              gap: "15px",
              maxWidth: isMobile ? "100%" : "300px",
            }}
          >
            <Box
              component="img"
              src={WhiteLogo}
              alt="Logo da Anota Reservas"
              sx={{ height: isMobile ? "40px" : "50px" }}
            />
            <Box
              sx={{
                color: "#fff",
                textAlign: isMobile ? "center" : "left",
                opacity: 0.9,
              }}
            >
              <p
                style={{
                  fontSize: "14px",
                  margin: 0,
                  fontFamily: "sans-serif",
                }}
              >
                Transforme sua quadra com agendamento automático
              </p>
            </Box>
          </Box>

          {/* CTA Section */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "15px",
            }}
          >
            <h3
              style={{
                color: "#fff",
                fontSize: isMobile ? "20px" : "24px",
                fontWeight: 600,
                margin: 0,
                textAlign: "center",
                fontFamily: "sans-serif",
              }}
            >
              Pronto para começar?
            </h3>
            <Button
              onClick={handleSignUpClick}
              variant="contained"
              sx={{
                background: "#fff",
                color: "#226FE2",
                padding: "12px 24px",
                borderRadius: "30px",
                fontWeight: 600,
                fontSize: "14px",
                textTransform: "none",
                boxShadow: "0 4px 14px rgba(255, 255, 255, 0.3)",
                "&:hover": {
                  background: "#f5f5f5",
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 20px rgba(255, 255, 255, 0.4)",
                },
                transition: "all 0.3s ease",
              }}
            >
              Teste grátis por 7 dias
            </Button>
          </Box>

          {/* Social Media */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: isMobile ? "center" : "flex-end",
              gap: "15px",
            }}
          >
            <p
              style={{
                color: "#fff",
                fontSize: "14px",
                margin: 0,
                opacity: 0.9,
                fontFamily: "sans-serif",
              }}
            >
              Siga-nos nas redes sociais
            </p>
            <Box
              sx={{
                display: "flex",
                gap: "15px",
                marginTop: isMobile ? "10px" : "0",
              }}
            >
              <a
                href="https://www.linkedin.com/in/anota-reservas-2405ba354"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn da Anota Reservas"
                onClick={() => handleSocialClick("linkedin")}
              >
                <Box
                  component="img"
                  src={LinkedinLogo}
                  alt="LinkedIn"
                  sx={{
                    height: isMobile ? "24px" : "30px",
                    cursor: "pointer",
                    transition: "transform 0.3s ease",
                    "&:hover": {
                      transform: "scale(1.1)",
                    },
                  }}
                />
              </a>
              <a
                href="https://www.instagram.com/anotareservas"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram da Anota Reservas"
                onClick={() => handleSocialClick("instagram")}
              >
                <Box
                  component="img"
                  src={InstagramLogo}
                  alt="Instagram"
                  sx={{
                    height: isMobile ? "24px" : "30px",
                    cursor: "pointer",
                    transition: "transform 0.3s ease",
                    "&:hover": {
                      transform: "scale(1.1)",
                    },
                  }}
                />
              </a>
            </Box>
          </Box>
        </Box>

        {/* Bottom Footer */}
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            maxWidth: "1200px",
            marginTop: "40px",
            paddingTop: "20px",
            borderTop: "1px solid rgba(255, 255, 255, 0.2)",
            gap: isMobile ? "15px" : "0",
          }}
        >
          <p
            style={{
              color: "#fff",
              fontSize: "12px",
              margin: 0,
              opacity: 0.7,
              fontFamily: "sans-serif",
            }}
          >
            © 2024 Anota Reservas. Todos os direitos reservados.
          </p>
          <Box
            sx={{
              display: "flex",
              gap: "20px",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            <a
              href="/termos"
              style={{
                color: "#fff",
                fontSize: "12px",
                textDecoration: "none",
                opacity: 0.7,
                fontFamily: "sans-serif",
              }}
            >
              Termos de Uso
            </a>
            <a
              href="/privacidade"
              style={{
                color: "#fff",
                fontSize: "12px",
                textDecoration: "none",
                opacity: 0.7,
                fontFamily: "sans-serif",
              }}
            >
              Política de Privacidade
            </a>
          </Box>
        </Box>
      </Box>
    </footer>
  );
};

export default Footer;
